import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';

import { Lang, toLang } from '../app.routes-config';

type CatalogModule = { default: TranslationObject };

const CATALOG_IMPORTS: Record<Lang, () => Promise<CatalogModule>> = {
  de: () => import('./de.json'),
  en: () => import('./en.json'),
  es: () => import('./es.json'),
  'es-419': () => import('./es-419.json'),
  fr: () => import('./fr.json'),
  hi: () => import('./hi.json'),
  id: () => import('./id.json'),
  it: () => import('./it.json'),
  ja: () => import('./ja.json'),
  ko: () => import('./ko.json'),
  'pt-br': () => import('./pt-br.json'),
  ru: () => import('./ru.json'),
  th: () => import('./th.json'),
  tr: () => import('./tr.json'),
  'zh-tw': () => import('./zh-tw.json'),
};

@Injectable()
export class LazyTranslateLoader extends TranslateLoader {
  getTranslation(lang: string): Observable<TranslationObject> {
    return from(CATALOG_IMPORTS[toLang(lang)]().then((catalogModule) => catalogModule.default));
  }
}
